export default __webpack_public_path__ + "static/context-dont-4-dark-6d1846da539c25de700b7833b1dd32d4.png";